import React from "react";
import AdminList from "./AdminList";
import Header from "../../components/Header";

const Admin = () => {
  return (
    <div className="mt-[2rem] min-h-screen">
      <div className="xl:w-[470px] mx-auto">
        <Header title="Meet our great team" subtitle="Discover the talent behind our excellence" />
      </div>
      <AdminList />
    </div>
  );
};

export default Admin;
